import { ReactNode } from "react";

function CenterMiddle(props: {
    contentStyle?: {
        [key: string]: any;
    };
    children?: ReactNode;
}) {
    return (
        <table style={{
            width: "100%",
            height: "100%",
            borderCollapse: "collapse",
            tableLayout: "auto",
            border: 0,
        }}>
            <tbody style={{
                width: "100%",
                height: "100%",
            }}>
                <tr style={{
                    width: "100%",
                    height: "100%",
                }}>
                    <td style={{
                        width: "100%",
                        height: "100%",
                        verticalAlign: "middle",
                        textAlign: "center",
                        overflow: "hidden"
                    }}>
                        {/* text-align: initial 还原成默认的值 */}
                        <div style={{
                            display: "inline-block",
                            textAlign: "initial",
                            ...props.contentStyle
                        }}>
                            {props.children}
                        </div>
                    </td>
                </tr>
            </tbody>
        </table >
    );
}
export default CenterMiddle;